import React from 'react';
import { CountdownProvider } from './contexts/CountdownContext';
import { UrgencyBar } from './components/UrgencyBar';
import { AttentionHero } from './components/AttentionHero';
import { Hero } from './components/Hero';
import { VideoSection } from './components/VideoSection';
import { PainPoints } from './components/PainPoints';
import { Benefits } from './components/Benefits';
import { Offer } from './components/Offer';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  return <CountdownProvider data-id="element-0" data-mp="31cte1nx7pu72">
      <div className="w-full bg-cream font-sans text-charcoal" data-id="element-1" data-mp="2wk0av4he6tx3">
        <UrgencyBar data-id="element-2" data-mp="2wip54z4dzc3c" />
        <main data-id="element-3" data-mp="2wi5mfg6wwjo9">
          <AttentionHero data-id="element-4" data-mp="28u5xmlt5v3cb" />
          <VideoSection data-id="element-5" data-mp="28te0v7ntuzkg" />
          <Hero data-id="element-6" data-mp="28surifc8tji1" />
          <PainPoints data-id="element-7" data-mp="28sbad0uf2z52" />
          <Benefits data-id="element-8" data-mp="23vkvuhy9gblr" />
          <Offer data-id="element-9" data-mp="23w4drynwuzzs" />
          <Testimonials data-id="element-10" data-mp="23ujlygszdv5m" />
          <Faq data-id="element-11" data-mp="23t8i6gzjcnei" />
          <FinalCta data-id="element-12" data-mp="3ijxpcqos80jw" />
        </main>
        <Footer data-id="element-13" data-mp="3ikqytzf4l45q" />
      </div>
    </CountdownProvider>;
}